export default __webpack_public_path__ + "static/subset-AkzidenzGroteskPro-BoldEx-9202293c8bf93fab9f076c0a4b6ce34c.woff";